import { DataTable, Dialog, Heading, Loader } from "@/components";
import useToleranceReport from "./useToleranceReport";
import { cn, formatAmount } from "@/lib/utils";
import { BUDGET, OVER, TOLERANCE } from "./consts";
import { Header } from "./Header";

const ToleranceReport = () => {
  const {
    breadcrumbData,
    communityDetail,
    isLoadingTolerance,
    toleranceData,
    summaryCards,
    totalExpense,
    onSummaryCardClick,
    filter,
    columns,
    openBomDialog,
    setOpenBomDialog,
    selectedRow,
    bomColumns,
    selectedOption,
    onOptionChanges,
    isRefetchingToleranceData
  } = useToleranceReport();
  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={`Tolerance 360 Report - ${communityDetail?.name}`}
            breadcrumbData={breadcrumbData}
          />
        </div>
        <Header option={selectedOption} onOptionChanges={onOptionChanges} />
        <div className="text-[15px] lg:text-[20px] text-primary flex flex-row gap-5 items-center">
          <span>#GL - {toleranceData?.data?.reportData?.length}</span>
          <span>Expense Amount - {formatAmount(totalExpense || "0")}</span>
        </div>
      </div>

      {isLoadingTolerance || isRefetchingToleranceData ? (
        <Loader />
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 text-white mb-10">
            {summaryCards?.map((data: any) => {
              return (
                <div
                  className={cn(
                    "rounded-sm p-4 gap-3 flex flex-col text-[15px] cursor-pointer",
                    data.className,
                    filter.includes(data.key) ? "opacity-100" : "opacity-50"
                  )}
                  onClick={() => onSummaryCardClick(data.key)}
                >
                  <span>{data?.title || ""}</span>
                  <div className="flex flex-row gap-3 items-center">
                    <div className="rounded-full bg-white p-3 flex items-center justify-center">
                      <img src={data?.icon} className="h-5 w-5" />
                    </div>
                    <span># Budget (GL) : {data?.noGl}</span>
                    <span>Amount : {formatAmount(data?.amount || "0")}</span>
                  </div>
                </div>
              );
            })}
          </div>

          <DataTable
            data={
              toleranceData?.data?.reportData?.filter((data: any) => {
                const {
                  approvedToDate = 0,
                  budgetYearlyAmt = 0,
                  actualToleranceAmt = 0,
                } = data;

                if (
                  filter.includes(BUDGET) &&
                  approvedToDate <= budgetYearlyAmt
                ) {
                  return true;
                }

                if (
                  filter.includes(TOLERANCE) &&
                  approvedToDate > budgetYearlyAmt &&
                  approvedToDate <= budgetYearlyAmt + actualToleranceAmt
                ) {
                  return true;
                }

                if (
                  filter.includes(OVER) &&
                  approvedToDate > budgetYearlyAmt + actualToleranceAmt
                  ) {
                  return true;
                }

                return false;
              }) || []
            }
            columns={columns}
          />
        </>
      )}

      {openBomDialog && (
        <Dialog
          open={openBomDialog}
          setOpen={setOpenBomDialog}
          title={
            <div className="text-xl font-bold text-primary">
              <span className="text-gray-400">{`BM Approval Distributions for - `}</span>{" "}
              {selectedRow?.glMasterId} - {selectedRow?.accountShortDesc}{" "}
              <span className="text-[15px]">
                (Total Approved Amt. -{" "}
                {formatAmount(
                  toleranceData?.data?.annualApprovalLimits?.bom || "0"
                )}
                )
              </span>
            </div>
          }
          hideFooter
        >
          <DataTable
            data={selectedRow?.positionApprovalStats || []}
            columns={bomColumns}
            className="shadow-none m-0 border-0"
            hideFooter
          />
        </Dialog>
      )}
    </div>
  );
};

export default ToleranceReport;
